// extracted by mini-css-extract-plugin
export default {"date":"rho_Ck","total":"J6gw0T","arrow":"L5qpn7"};